import React, { useEffect } from "react";
import { ContactsSegment } from "../Components/ContactsSegment";
import {
  SegmentsWrapper,
  CustomGenericListStyleSegments,
} from "../Marketing.styled";
import { useMediaQueries } from "../../../../../../utils/mediaQueries";
import { useStore } from "../../../../../../hooks";
import { observer } from "mobx-react";
import Spinner from "../../../../../../components/common/Spinner";

const Segments = observer(() => {
  const { isTablet } = useMediaQueries();
  const {  marketingStore, contactSegmentStore } = useStore();

  const prepareContactFileData = () => {
    return {
      file: contactSegmentStore.fileId.split("/")[1],
      numberSegments: contactSegmentStore.parsedContactList.length,
      name: contactSegmentStore.fileUploaded?.name,
      billingVariables: Object.keys(contactSegmentStore.finalFixedMappings).length > 0
        ? Object.keys(contactSegmentStore.finalFixedMappings)
        : [],
      sources: contactSegmentStore.emailTemplateEventSourceList,
    }
  }

  const onFileUpload = () => {
    const data = prepareContactFileData();
    marketingStore.setContactFile(data);
  }
  
  useEffect(() => {
    if (marketingStore.currentCampaign) {
      contactSegmentStore.clear();
      contactSegmentStore.init({ account: marketingStore.customer });
      contactSegmentStore.setFileId(`${marketingStore.currentCampaign.idRef}/${marketingStore.currentCampaign.idRef}_contacts`);
      if (marketingStore.currentCampaign.metadata?.uploaded_contact_file) {
        contactSegmentStore.updateGeneralField("fileUploaded", {name: marketingStore.currentCampaign.metadata.uploaded_contact_file});
        contactSegmentStore.setIsFileUploaded(true); 
      } else {
        contactSegmentStore.setIsFileUploaded(false);
      }
    }
  }, [marketingStore.currentCampaign]);

  if (!marketingStore.currentCampaign) {
    return <Spinner />;
  }
  
  return (
    <SegmentsWrapper isTablet={isTablet}>
      <ContactsSegment 
        onFileUpload={onFileUpload}
        filters={marketingStore.currentCampaign?.metadata?.filters || []}
        showFile={marketingStore.existingFileContacts}
      />
      {isTablet && <CustomGenericListStyleSegments />}
    </SegmentsWrapper>
  );
});

export default Segments;
